import gql from 'graphql-tag';

const GET_HASHED_EMAIL_LIST_WITH_COUNT = gql`
  query getHashedEmailListWithCount($orgId: String, $searchTerm: String) {
    getHashedEmailListWithCount(orgId: $orgId, searchTerm: $searchTerm)
  }
`;

export default GET_HASHED_EMAIL_LIST_WITH_COUNT;
